var _path, _path2, _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWechat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.949 11.207C18.494 7.714 15.074 5 10.923 5c-4.46 0-8.077 3.134-8.077 7 0 1.655.663 3.177 1.772 4.375.33.357.133 1.603.053 2.037a.11.11 0 00.122.13c.55-.07 2.44-.292 2.99-.091a9.133 9.133 0 003.14.549c.99 0 1.94-.155 2.817-.438",
    stroke: "#fff",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.075 19.56h0c-.012-.002-.331-.06-.683-.101a5.683 5.683 0 00-.489-.04c-.07-.002-.12-.001-.153.002h-.005a5.58 5.58 0 01-1.899.329c-2.696 0-5.058-1.932-5.058-4.52 0-2.586 2.362-4.519 5.058-4.519 2.696 0 5.058 1.933 5.058 4.52 0 1.043-.395 1.994-1.04 2.747-.001.059.002.137.01.23.02.225.064.436.068.457l.004.016c.002.013.01.055.012.11a.751.751 0 01-.883.769zm-1.347-.137h.002-.002z",
    stroke: "#fff",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.154,
    cy: 10.385,
    r: 0.75,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.654
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 14.423,
    r: 0.75,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.115
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.462,
    cy: 10.385,
    r: 0.75,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.654
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.73,
    cy: 14.423,
    r: 0.75,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.115
  })));
}
export default SvgWechat;